import { render, staticRenderFns } from "./BaseArtwork.vue?vue&type=template&id=a5ec1fb8&scoped=true&"
import script from "./BaseArtwork.vue?vue&type=script&lang=js&"
export * from "./BaseArtwork.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=a5ec1fb8&scoped=true&lang=css&"
import style1 from "./BaseArtwork.vue?vue&type=style&index=1&id=a5ec1fb8&scoped=true&lang=css&"
import style2 from "../assets/css/base-bevelanimations.css?vue&type=style&index=2&id=a5ec1fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ec1fb8",
  null
  
)

export default component.exports